import React, {useMemo, useState, useEffect} from "react";
import "./../../utils/Style/pages/Employees.scss";
import {useTable} from "react-table";
import {faArrowDown, faUser} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Table from "../../components/Table";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {
    setEmployeesError
} from "../../features/employeesSlice";

import {useDispatch, useSelector} from "react-redux";
import {format} from "date-fns";
import {useOutletContext} from "react-router-dom";
import {Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay} from "@chakra-ui/react";
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import {fetchLegalEmployees} from "../../features/legalEmployeesSlice";
import {capitalizeFirstLetters} from "../../features/ValueFormater";
import {handleImageError} from "../../utils/functions";

function MerchantEmployeeTemplate() {
    const {status} = useSelector((state) => state.authorization);
    const {employees} = useSelector((state) => state.legalEmployees)
    const {positions, loading} = useSelector((state) => state.employees);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [employeesList, setEmployeesList] = useState([]);
    const [disabledEdit, setDisabledEdit] = useState(false);

    const [roles, setRoles] = useState([]);
    const [editId, setEditId] = useState(-1);

    const entityRole = sessionStorage.getItem("EntityRole");

    const [employeeDetails, setEmployeeDetails] = useState({
        EmployeeID: "",
        FullName: "",
        Position: "",
        RoleID: "",
        ShowBlockButton: false,
    });

    const [editEmployeeDetails, setEditEmployeeDetails] = useState({
        EmployeeID: "",
        RoleID: "",
        newBranchID: "",
        oldBranchID: "",
        Email: "",
    });
    const [modalOpen, setModalOpen] = useState(false);

    const [onOpenQrAfterGenerate] = useOutletContext();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchLegalEmployees());
        return () => {
            dispatch(setEmployeesError(null));
        };
    }, []);

    useEffect(() => {
        setEmployeesList(employees);
        setRoles(positions);
    }, [employees, positions]);

    useEffect(() => {
        if (status === "COMPLETE") {
            setModalOpen(false);
        }
    }, [status])

    const handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        setEditEmployeeDetails((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleBlock = (id) => {
        const payload = {
            EmployeeId: id,
        }
        dispatch(setActionType(ACTION_TYPES.BLOCK_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }
    const handleDelete = (id) => {
        const payload = {
            EmployeeId: id,
        }
        setModalOpen(false);
        dispatch(setActionType(ACTION_TYPES.DELETE_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }
    const handleEdit = (id) => {
        editId === -1 ? setEditId(id) : setEditId(-1);
        setDisabledEdit(true);
        setEditEmployeeDetails({
            EmployeeID: employeeDetails.EmployeeID,
            RoleID: employeeDetails.RoleID
        })
    }
    const confirmEdit = (id) => {
        const payload = {
            EmployeeID: editEmployeeDetails.EmployeeID,
            RoleID: parseInt(editEmployeeDetails.RoleID)
        }
        setModalOpen(false);
        dispatch(setActionType(ACTION_TYPES.EDIT_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
        setEditId(-1);
    }

    const handleClick = (row) => {
            setEmployeeDetails({
                EmployeeID: row.original.EmployeeID,
                FullName: row.original.FullName,
                Position: row.original.Position,
                BranchID: row.original.BranchID,
                MobileNo: row.original.MobileNo,
                Email: row.original.Email,
                ShowBlockButton: row.original.ShowBlockButton,
            });
            setModalOpen(true)
    }

    const columns = useMemo(
        () => [
            {
                Header: "Employee Name",
                accessor: "FullName",
                Cell: ({row, cell: {value}}) => {
                    return <div className="showmore">
                        {
                            row.original.ImageUrl ? (
                                <div className="row">
                                    <div className="col-1 avatar-employee p-0"><img id="employeesListAvatar" src={row.original.ImageUrl} alt="avatar" onError={handleImageError}/></div>
                                    <div className="col-9 pt-2">{capitalizeFirstLetters(value)}</div>
                                </div>
                            ) : (
                                <div className="row">
                                    <span className="me-2"><FontAwesomeIcon icon={faUser}/></span> {value}
                                </div>
                            )

                        }
                    </div>
                },
            },
            {
                Header: "Position",
                accessor: "Position",
                Cell: ({value})=>{
                    return capitalizeFirstLetters(value);
                }
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Merchant",
                accessor: "Entity",
            },
            {
                Header: "Last Access Date",
                accessor: "DateLastAccess",
                Cell: ({value}) =>
                    value ? format(new Date(value), "dd/MM/yyyy") : value,
            },
            {
                Header: "Phone Number",
                accessor: "MobileNo",
            },
            {
                Header: "Email",
                accessor: "Email",
            },
            {
                Header: "Action",
                accessor: "Action",
                Cell: ({row}) => {
                    if(!row.original.ShowBlockButton) return <></>
                    if (row.original.isBlocked) {
                        return <button
                            className="details Unblock"
                            onClick={() => {
                                handleBlock(row.original.EmployeeID);
                            }}
                            disabled={entityRole === "Supervisor"}
                        >Unblock</button>;
                    } else {
                        return <button
                            className="details"
                            onClick={() => {
                                handleBlock(row.original.EmployeeID);
                            }}
                            disabled={entityRole === "Supervisor"}
                        >Block</button>;
                    }
                },
            }
        ],
        [employees]
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({columns, data: employeesList || []});

    return (
        <>
    
            <div className="employeesTable">
                {loading === "pending" ? (
                    <TableSkeleton/>
                ) : (
                    <Table
                        headerGroups={headerGroups}
                        page={rows}
                        prepareRow={prepareRow}
                        getTableProps={getTableProps}
                        getTableBodyProps={getTableBodyProps}
                        activeRowIndex={activeRowIndex}
                        setActiveRowIndex={setActiveRowIndex}
                        handleClick={handleClick}
                        employee={true}
                    />
                )}

            </div>

            {/* Modal */}
            <div id="modal-part">
                <Modal isOpen={modalOpen && entityRole !== "Supervisor"} isCentered >
                    <ModalOverlay/>

                    <ModalContent maxW={'40%'}>
                        <ModalHeader>
                            <div id="modalHeader">
                                <div></div>
                                <h2>Employee Details</h2>
                                <button type="button" className="btn-close" onClick={() => {
                                    setModalOpen(false);
                                    setDisabledEdit(false)
                                }}></button>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <div id="employee-modal">
                                <div className="chak-modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body EditEmployee">
                                            <div className="modalBody">
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Name</div>
                                                    <div className="col-8 subDesc">{employeeDetails.FullName}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Position</div>
                                                    {disabledEdit ?
                                                        <select className="col-8 subDesc" name="RoleID" id="account"
                                                                defaultValue={employeeDetails.Position}
                                                                onChange={handleInputChange}>
                                                            {roles.map((role) => <option key={role.value}
                                                                                         value={role.value}>{role.label}</option>)}
                                                        </select>
                                                        :
                                                        <div className="col-8 subDesc">{capitalizeFirstLetters(employeeDetails.Position)}</div>
                                                    }
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Phone Number</div>
                                                    <div className="col-8 subDesc">{employeeDetails.MobileNo}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-4 subTitle">Email</div>
                                                    {disabledEdit ?
                                                        <input className="col-8 subDesc" name="Email"
                                                               defaultValue={employeeDetails.Email}
                                                            // onChange={handleInputChange}
                                                               disabled
                                                        />
                                                        :
                                                        <div className="col-8 subDesc">{employeeDetails.Email}</div>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                employeeDetails.ShowBlockButton &&
                                                <div className="modalFooter">
                                                    <button className="DeletEmployee" onClick={() => {
                                                        handleDelete(employeeDetails.EmployeeID)
                                                    }}>Delete Employee
                                                    </button>
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </>
    );
}

export default MerchantEmployeeTemplate;